export const UserRegistrationAdminFilterKey = {
  Step: 'step',
} as const;
export type UserRegistrationAdminFilterKey =
  (typeof UserRegistrationAdminFilterKey)[keyof typeof UserRegistrationAdminFilterKey];
export const USER_REGISTRATION_ADMIN_FILTER_KEYS = [UserRegistrationAdminFilterKey.Step] as const;
